import type { RateDescriptionCopy } from 'v5/core/rates/describeRate';

export const CORE_LABEL_NAMES = [
  'full_name',
  'pronouns',
  'emails',
  'phone_numbers',
  'socials',
  'websites',
  'tags',
  'groups',
  'locations',
  'rates',
  'represented_by_id',
  'organisation_id',
  'nick_name',
  'role'
] as const;
/** Core fields the resource form names (`MetastructureFieldCore.name`). */
export type CoreLabelName = (typeof CORE_LABEL_NAMES)[number];

/**
 * The words of a resolved resource schema, in the user's language. The host
 * translates them; custom field names are the organisation's own and stay
 * as they are.
 */
export type ResourceSchemaCopy = {
  coreLabel: Record<CoreLabelName, string>;
  /** Placeholder of a text input for `label` ("Enter role"). */
  enterPlaceholder(label: string): string;
  globalSection: string;
  /** A workspace section with no fields of its own (`workspaceName`). */
  emptyWorkspaceSection(workspaceName: string): string;
  rateItemTitle: string;
  /** The link to the rate cards settings in the add menu. */
  manageRateCards: string;
  /** One row of the locations list ("Location"). */
  locationItemTitle: string;
  addRate: string;
  blankRate: string;
  blankRateHint: string;
  fromRateCard: string;
  /** A list of a custom field group's rows (`name`): its add button. */
  addItem(name: string): string;
  /** The rate card line in the add menu ("GBP 1,200 / day · +20% agency"). */
  rateCard: RateDescriptionCopy;
};
